var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.progress},[_c('div',{class:_vm.$style.indeterminate})])
}
var staticRenderFns = []

export { render, staticRenderFns }